'use client'

import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { cn } from '../lib/cn'

export const Dialog = BaseDialog.Root
export const DialogTrigger = BaseDialog.Trigger

export function DialogBackdrop({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof BaseDialog.Backdrop>) {
  return (
    <BaseDialog.Backdrop
      className={cn(
        'fixed inset-0 bg-warm-gray-900/40 backdrop-blur-sm',
        'transition-opacity duration-300',
        'data-[open]:opacity-100 data-[closed]:opacity-0',
        className
      )}
      {...props}
    />
  )
}

export function DialogPopup({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof BaseDialog.Popup>) {
  return (
    <BaseDialog.Portal>
      <DialogBackdrop />
      <BaseDialog.Popup
        className={cn(
          'fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
          'w-full max-w-md rounded-3xl bg-white p-8 shadow-warm-lg',
          'transition-all duration-300',
          'data-[open]:opacity-100 data-[open]:scale-100',
          'data-[closed]:opacity-0 data-[closed]:scale-95',
          className
        )}
        {...props}
      >
        {children}
      </BaseDialog.Popup>
    </BaseDialog.Portal>
  )
}

export function DialogTitle({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof BaseDialog.Title>) {
  return (
    <BaseDialog.Title
      className={cn('font-serif text-2xl font-semibold text-warm-gray-900 mb-2', className)}
      {...props}
    />
  )
}

export function DialogDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof BaseDialog.Description>) {
  return (
    <BaseDialog.Description
      className={cn('text-warm-gray-600 text-sm mb-6', className)}
      {...props}
    />
  )
}

export function DialogClose({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof BaseDialog.Close>) {
  return (
    <BaseDialog.Close
      className={cn(
        'absolute right-5 top-5 rounded-xl p-1.5',
        'text-warm-gray-400 hover:text-warm-gray-600 hover:bg-cream-100',
        'transition-colors duration-150',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-400',
        className
      )}
      {...props}
    />
  )
}
